module.exports = __webpack_public_path__ + "static/media/_moldova.32899cea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_moldova.svg
// module id = 2339
// module chunks = 7